import {
	SET_TOTAL_NOTIFICATION_ACTION,
	SET_LIST_NOTIFICATION_ACTION,
	SET_NOTIFICATION_DETAIL_ACTION,
	MENU_NOTIFICATION_ACTION
} from "../actions/NotificationPageAction/actionTypes";

const initialState = {
	total: 0,
	notifications: [],
	notificationDetail: {},
	menuActive: 0
};

const notificationPageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_TOTAL_NOTIFICATION_ACTION: {
			return {
				...state,
				total: action.params
			};
		}
		case SET_LIST_NOTIFICATION_ACTION: {
			return {
				...state,
				notifications: action.params ? action.params : []
			};
		}
		case SET_NOTIFICATION_DETAIL_ACTION: {
			return {
				...state,
				notificationDetail: action.params ? action.params : {}
			};
		}
		case MENU_NOTIFICATION_ACTION: {
			return {
				...state,
				menuActive: action.params || 0
			};
		}
		default:
			return state;
	}
};

export default notificationPageReducer;
